module.exports = __webpack_public_path__ + "static/media/map12.8e55ae42.webp";